module.exports = __webpack_public_path__ + "img/icons8-microsoft-excel-2019.6543c550.svg";